import { h } from 'preact';

import { ImageAnnotation } from './index';
import { expandable } from 'rendering/behaviors/expandable';
import { BaseAnnotation } from 'rendering/annotations/base_annotation';
import { ControlBar } from 'rendering/components/adjacent_control_bar';
import { COMPOSITION_TYPES } from 'constants/annotations';

const { IMAGE } = COMPOSITION_TYPES;

@expandable
export class AdjacentImageAnnotation extends ImageAnnotation {
    static scalable = false;

    render () {
        return (
            <div { ...this.attrs }>
                <ControlBar onExpand={ this.onExpand } onCollapse={ this.onCollapse } styles={ this.controlBarStyles }/>
            </div>
        );
    }

    getElementStyles(...args) {
        const styles = super.getElementStyles(...args),
            baseStyles = BaseAnnotation.prototype.getElementStyles.call(this, ...args); // get base styles to avoid inheritting Image Annotation style defaults

        return {
            ...styles,
            backgroundSize: baseStyles.backgroundSize || 'cover',
            width: '100%',
            height: '100%',
            left: 0,
            top: 0
        }
    }
}